import { useEffect } from 'react';
import { useNavigate } from 'react-router';

/**
 * 모임 생성 완료 직후 브라우저 뒤로가기로 create 플로우(step1~3)에 재진입하는 것을
 * 차단한다. MeetingShare / TravelMeetingShare 가 'meeting_create_completed'=1 을
 * sessionStorage 에 세팅한 뒤 location.replace 로 상세/홈 이동하므로, create 단계
 * 컴포넌트가 마운트될 때 플래그가 있으면 곧바로 /home 으로 치환 이동.
 */
export const useSkipIfCreated = () => {
    const navigate = useNavigate();
    useEffect(() => {
        try {
            if (sessionStorage.getItem('meeting_create_completed') === '1') {
                sessionStorage.removeItem('meeting_create_completed');
                navigate('/home', { replace: true });
            }
        } catch { /* noop */ }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
